import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Container from '../../components/Layout/Container';
import PageTopBanner from '../../components/PageTopBanner';
import { TabsLink } from '../../components/Tab/Tabs';
import { technicalIntroData } from '../../components/Tab/TabData';
import ToggleLanguage from '../../components/ToggleLanguage';
import Pagination from 'react-js-pagination';
import useScreenSize from '../../hooks/useScreenSize';
import Input, { onEnter } from '../../components/TextField/Input';
import Loading from '../Loading';

import { fetchGet } from '../../hooks/fetch';
import useSearch from '../../hooks/useSearch';

export default function PlatformStartup() {
	const navigate = useNavigate();
	const screenSize = useScreenSize();

	const [posts, setPosts] = useState([]);
	const [pagingInfo, setPagingInfo] = useState({ totalCount: 0 });
	const [isLoading, setIsLoading] = useState(true);
	const [activeTab, setActiveTab] = useState('');

	const postPerPage = 10;
	const pageName = 'Startup';

	const { page, searchText, language, isSearchable, updateParams } = useSearch(
		{
			minSearchLength: 2,
			defaultLanguage: 'ko',
		}, 'startup');

	useEffect(() => {
		if (!isSearchable) return;
		setIsLoading(true);

		fetchGet(
			`/platform/startup?page=${page}&searchText=${searchText}&language=${language}`,
			(json) => {
				setPosts(json?.dataList || []);
				setPagingInfo(json?.pagingInfo || { totalCount: 0 });
				setIsLoading(false);
			}
		);
	}, [page, searchText, language, isSearchable]);

	const onChangeSearchText = (e) => {
		updateParams({
			page: 1,
			searchText: e.target.value,
		});
	};

	const onSearch = () => {
		if (!isSearchable) return;
		updateParams({ searchText });
	};

	const handlePageChange = (p) => {
		updateParams({ page: p });
	};

	const handleSelectLanguage = (lang) => {
		updateParams({ language: lang });
	};

	const goDetail = (uid) => {
		navigate(`/platform/startup/${uid}?page=${page}&searchText=${searchText}&language=${language}`);
	};

	return (
		<main id="technical-intro-page-wrap" className="map-page">
		<h1 className="sr-only">{pageName} 페이지</h1>

		<PageTopBanner />

		<Container>
			<TabsLink
				className="sub-page-tab-con"
				tabsData={technicalIntroData}
				activatedTab={activeTab}
				onTabChange={setActiveTab}
			/>

			<div className="page-content">
					<div className="content-top">
						<div>
							<h1 className="title">{pageName}</h1>
						</div>
						<ToggleLanguage index={language} onChange={handleSelectLanguage} />
					</div>

					<div>
						<div className="gs-total-search">
							<div className="search">
								<Input
									id="total-search-input"
									type="search"
									label="검색어를 입력해주세요."
									placeholder="검색어 입력"
									value={searchText}
									maxLength={15}
									onChange={onChangeSearchText}
									onKeyDown={(e) => onEnter(e, onSearch)}
								/>
								<button type="submit" onClick={onSearch}>
									<span className="sr-only">검색하기</span>
								</button>
							</div>
						</div>

						<div className="gs-list-con technical-intro-list">
							<ul>
								{pagingInfo.totalCount === 0 || posts === undefined ? (
									isLoading ? <Loading /> :
									<li>
										<div className="gs-no-con">등록된 내용이 없습니다.</div>
									</li>
								) : (
									posts.map((post, i) => {
										return (
											<li key={i} className="item">
												<a onClick={() => goDetail(post?.uid)}>
													<div className="left">
														<h2>{post.name}</h2>
														<ul><li>{post.representative} / {post.company} {post.position}</li></ul>
													</div>
													<div className="right">
														<h2>{post.summary}</h2>
														<ul>
															{post.diseases !== null && <li className="gs-bullet hyphen">{post.diseases}</li>}
															{post.hope !== null && <li className="gs-bullet hyphen">{post.hope}</li>}
														</ul>
													</div>
												</a>
											</li>
										)
									}
								))}
							</ul>
						</div>

						{pagingInfo.totalCount > 0 && (
							<Pagination
								innerClass="gs-pagination"
								// itemClass="pg-item"
								linkClass="btn"
								itemClassFirst="pg-arrow pg-first"
								itemClassPrev="pg-arrow pg-prev"
								itemClassNext="pg-arrow pg-next"
								itemClassLast="pg-arrow pg-last"
								firstPageText={null} // 첫 번째 페이지 탐색 버튼의 텍스트
								prevPageText={null} // 이전 페이지 탐색 버튼의 텍스트
								nextPageText={null} // 다음 페이지 탐색 버튼의 텍스트
								lastPageText={null} // 마지막 페이지 탐색 버튼의 텍스트
								activePage={page} // 현재 페이지
								totalItemsCount={pagingInfo.totalCount} // 총 아이템 갯수
								itemsCountPerPage={postPerPage} // 한 페이지랑 보여줄 아이템 갯수
								pageRangeDisplayed={screenSize.width >= 480 ? 5 : 3} // paginator의 페이지 범위 (useScreenSize custom hook 사용)
								onChange={handlePageChange} // 페이지 변경을 핸들링하는 함수
							/>
						)}
					</div>
				</div>
		</Container>
		</main>
	);
}
